exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1UhbP9x3 {\n  align-self: flex-start;\n  padding: 4px;\n}\n\n._2jphHd4H {\n  flex-direction: row;\n}\n\n._2GHXlTO8 {\n  background-color: #14171A;\n}\n\n._24AUQK41 {\n  background-color: #AAB8C2;\n}\n\n._3GfxlQ5K {\n  background-color: #E6ECF0;\n}\n\n._3NqNGK87 {\n  background-color: #FFAD1F;\n}\n\n._2WCApj1u {\n  background-color: #F45D22;\n}\n\n._3Hkan-D- {\n  background-color: #E0245E;\n}\n\n.JnwOt3cu {\n  width: 6px;\n  height: 6px;\n}\n", ""]);

// Exports
exports.locals = {
	"outer": "_1UhbP9x3",
	"row": "_2jphHd4H",
	"color0": "_2GHXlTO8",
	"color1": "_24AUQK41",
	"color2": "_3GfxlQ5K",
	"color3": "_3NqNGK87",
	"color4": "_2WCApj1u",
	"color5": "_3Hkan-D-",
	"fixed": "JnwOt3cu"
};